import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import History from "@/shared/model/History";
import HistoryListItemComponent from "@/modules/History/components/HistoryListItemComponent.vue";
import {ref, watch} from "vue";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";

interface Props {
  data?: History[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HistoryListComponent',
  props: {
    data: { default: undefined }
  },
  setup(__props: any) {


const _data = ref<History[]>([])
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = __props


/*
watch(props, () => {
  console.log(props.data)
  _data.value.length = 0;
  if (!props.data)
    return
  const ar = props.data ?? _data.value;
  ar.sort((a, b) => {
    return +new Date(b.date ?? 0) - +new Date(a.date ?? 0);
  }).map(t => _data.value.push(t))
}, {immediate: true})
*/

watch(
    () => props.data,
    (newVal) => {
      if (!newVal) {
        _data.value = []
        return
      }

      _data.value = [...newVal].sort((a, b) => {
        return +new Date(b.date ?? 0) - +new Date(a.date ?? 0)
      })
    },
    { immediate: true, deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogFlexColumn, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_data.value, (item) => {
        return (_openBlock(), _createBlock(HistoryListItemComponent, {
          key: item.id,
          style: {"justify-content":"left"},
          data: item
        }, null, 8, ["data"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})